module.exports = __webpack_public_path__ + "img/logo-sm.04453a1c.svg";